import { defineComponent as X, computed as s, useAttrs as Y, ref as z, createElementBlock as b, openBlock as h, normalizeStyle as g, normalizeClass as w, createElementVNode as y, createCommentVNode as Z, Fragment as B, renderList as N, mergeProps as _, toHandlers as ee } from "vue";
import { useThrottleFn as te } from "@vueuse/core";
import { omit as ae } from "../../utils/omit.js";
import { tw as n } from "../../utils/tailwind.js";
import { Multipliers as A } from "./SliderBase.constant.js";
import { getTrackSize as le, getTrackPosition as k, getTrackValue as M, getUpdatedValue as R, getClosestStep as F } from "./SliderBase.helpers.js";
const oe = { class: "relative flex h-32 items-center lg:h-24" }, se = ["disabled"], ne = ["aria-disabled", "aria-label", "aria-valuemax", "aria-valuemin", "aria-valuenow", "tabindex"], re = ["value"], ve = /* @__PURE__ */ X({
  name: "RevSliderBase",
  inheritAttrs: !1,
  __name: "SliderBase",
  props: {
    disabled: { type: Boolean, default: !1 },
    keyboardStep: { default: 1 },
    label: {},
    max: {},
    min: { default: 0 },
    modelValue: {},
    showSteps: { type: Boolean, default: !1 },
    step: { default: 1 }
  },
  emits: ["update:modelValue"],
  setup(P, { emit: U }) {
    const e = P, $ = U, j = s(() => ae(Y(), ["class", "style"])), p = z(null), m = z([]), V = s(() => e.modelValue.length === 1), H = s(() => e.modelValue.join(","));
    function v(t) {
      $("update:modelValue", t);
    }
    function E(t, a) {
      if (a === "keyboard") {
        m.value[t]?.focus();
        return;
      }
      m.value[t]?.dispatchEvent(new Event("mousedown"));
      try {
        m.value[t]?.dispatchEvent(new TouchEvent("touchstart"));
      } catch {
      }
    }
    const I = s(() => {
      const [t, a] = V.value ? [e.min, e.modelValue[0]] : e.modelValue;
      return {
        left: k(t, e.min, e.max),
        width: le(t, a, e.min, e.max)
      };
    }), S = s(() => {
      const t = [];
      for (let a = e.min; a <= e.max; a += e.step)
        t.push(a);
      return t;
    }), K = s(
      () => S.value.map((t) => ({
        left: k(t, e.min, e.max)
      }))
    ), W = s(() => e.disabled ? "-1" : "0"), q = s(() => e.modelValue.map((t, a) => {
      let r = 0, o = 0;
      const c = te((l) => {
        const i = M(
          l,
          r,
          o,
          e.min,
          e.max,
          e.step
        );
        D(i, "");
      }, 10), u = () => {
        r = 0, o = 0, document.removeEventListener("touchmove", c), document.removeEventListener("touchend", u), document.removeEventListener("mousemove", c), document.removeEventListener("mouseup", u);
      }, D = (l, i) => {
        if (!e.disabled) {
          if (V.value) {
            v([l]);
            return;
          }
          if (a === 0 && l > e.modelValue[1]) {
            u(), E(1, i), v([e.modelValue[1], l]);
            return;
          }
          if (a === 1 && l < e.modelValue[0]) {
            u(), E(0, i), v([l, e.modelValue[0]]);
            return;
          }
          v(R(e.modelValue, a, l));
        }
      }, T = (l) => {
        if (l.preventDefault(), !p.value)
          return;
        const { left: i, width: d } = p.value.getBoundingClientRect();
        r = i, o = d, "touches" in l ? (document.addEventListener("touchmove", c), document.addEventListener("touchend", u)) : (document.addEventListener("mousemove", c), document.addEventListener("mouseup", u)), m.value[a]?.focus();
      };
      return {
        listeners: {
          keydown: (l) => {
            const i = l.shiftKey ? A.Shift : A.Default;
            let d = t;
            switch (l.code) {
              case "ArrowUp":
              case "ArrowRight":
                d += i * e.keyboardStep * e.step, d = F(
                  d,
                  e.min,
                  e.max,
                  e.step
                );
                break;
              case "ArrowDown":
              case "ArrowLeft":
                d -= i * e.keyboardStep * e.step, d = F(
                  d,
                  e.min,
                  e.max,
                  e.step
                );
                break;
              default:
                return;
            }
            l.preventDefault(), D(d, "keyboard");
          },
          mousedown: T,
          touchstart: T
        },
        style: {
          left: k(t, e.min, e.max)
        }
      };
    }));
    function x(t) {
      if (t.preventDefault(), e.disabled || !p.value)
        return;
      const { left: a, width: r } = p.value.getBoundingClientRect(), o = M(
        t,
        a,
        r,
        e.min,
        e.max,
        e.step
      );
      let f;
      if (e.modelValue[0] === e.modelValue[1])
        f = o > e.modelValue[0] ? 1 : 0;
      else {
        const c = e.modelValue.map((u) => Math.abs(u - o));
        f = c.findIndex((u) => u === Math.min(...c));
      }
      v(R(e.modelValue, f, o)), m.value[f]?.dispatchEvent(new Event("mousedown"));
      try {
        m.value[f]?.dispatchEvent(new TouchEvent("touchstart"));
      } catch {
      }
    }
    const C = n`rounded-sm border-2`, G = [
      C,
      n`border-static-default-low w-full cursor-pointer disabled:cursor-not-allowed`
    ], J = s(() => [
      C,
      n`border-static-default-hi pointer-events-none absolute`,
      e.disabled && n`hidden`
    ]), L = s(() => [
      n`bg-action-default-low rounded-md absolute top-1/2 -translate-x-1/2 -translate-y-1/2`,
      n`after:rounded-md after:absolute after:left-1/2 after:top-1/2 after:size-4 after:-translate-x-1/2 after:-translate-y-1/2 after:bg-current after:content-['']`
    ]), O = s(() => [
      L.value,
      n`pointer-events-none z-[1] size-12`,
      e.disabled && n`bg-action-default-low-disabled text-action-default-low-disabled`
    ]), Q = s(() => [
      L.value,
      n`z-10 size-28 border`,
      e.disabled ? n`border-action-default-hi-disabled pointer-events-none cursor-not-allowed before:bg-action-default-low-disabled before:rounded-sm after:text-onaction-default-low-disabled before:absolute before:inset-0` : n`border-action-default-hi focus-visible-outline-default-hi cursor-pointer after:text-onaction-default-low hover:bg-action-default-low-hover hover:shadow-long`
    ]);
    return (t, a) => (h(), b("div", {
      class: w(["isolate px-16 lg:px-14", t.$attrs.class]),
      style: g(t.$attrs.style)
    }, [
      y("div", oe, [
        y("button", {
          ref_key: "track",
          ref: p,
          "aria-hidden": "",
          class: w(G),
          disabled: t.disabled,
          tabindex: "-1",
          variant: "primary",
          onMousedown: x,
          onTouchstart: x
        }, null, 40, se),
        y("div", {
          class: w(J.value),
          "data-test": "sliderbase-selection",
          style: g(I.value)
        }, null, 6),
        t.showSteps ? (h(!0), b(B, { key: 0 }, N(S.value, (r, o) => (h(), b("span", {
          key: r,
          "aria-hidden": "",
          class: w(O.value),
          role: "presentation",
          style: g(K.value[o])
        }, null, 6))), 128)) : Z("", !0),
        (h(!0), b(B, null, N(q.value, (r, o) => (h(), b("span", _({
          key: o,
          ref_for: !0,
          ref_key: "thumbs",
          ref: m,
          "aria-disabled": t.disabled,
          "aria-label": t.label[o],
          "aria-orientation": "horizontal",
          "aria-valuemax": t.max,
          "aria-valuemin": t.min,
          "aria-valuenow": t.modelValue[o],
          class: Q.value,
          role: "slider",
          style: r.style,
          tabindex: W.value
        }, ee(r.listeners, !0)), null, 16, ne))), 128)),
        y("input", _(j.value, {
          type: "hidden",
          value: H.value
        }), null, 16, re)
      ])
    ], 6));
  }
});
export {
  ve as default
};
